import { useState, useCallback } from 'react';

const useOxTabs = (initialIndex?: number) => {
  const [index, setIndex] = useState(initialIndex || 0);

  const handleChange = useCallback(
    (_: React.SyntheticEvent, newValue: number) => {
      setIndex(newValue);
    },
    [],
  );

  return {
    tabIndex: index,
    handleTabChange: handleChange,
  };
};

export default useOxTabs;
